var powerstepContainer = document.getElementById("powerstep-container");
var powerstepDiscount = document.querySelector("#powerstep-container_discount");
if (powerstepContainer) {
  document.querySelectorAll('[data-powerstep="true"]').forEach(el => el.addEventListener("click", togglePowerstep));
  const elementsPowerstep = ["#powerstep__close-btn", "#powerstep-overlay", "#powerstep-continue-shopping"];
  elementsPowerstep.forEach(function (item, index) {
    powerstepContainer.querySelector(item)?.addEventListener("click", togglePowerstep);
  });
}

document.querySelectorAll('[data-powerstep-discount="true"]').forEach(el => el.addEventListener("click", togglePowerstepDiscount));

function togglePowerstep(e) {
  powerstepContainer.classList.toggle("hidden");
  document.querySelector("body").classList.toggle("no-scroll");
}
function togglePowerstepDiscount(e) {
  let discountProductId = e.target.getAttribute("data-discount-product-id");
  var discountProductElement = $(powerstepContainer).find("[data-discount-product]");
  if (discountProductId) {
    if (discountProductElement) {
      $(discountProductElement).removeClass("d-none");
    }
    addDiscountProductToCart(discountProductId);
  } else {
    if (discountProductElement) {
      $(discountProductElement).addClass("d-none");
    }
  }
  powerstepDiscount.classList.toggle("hidden");
  document.querySelector("body").classList.toggle("no-scroll");
}

function addDiscountProductToCart(selectedId) {
  let productIsInCart;
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => {
    return res.json();
  }).then((data) => {
    data.items.map(item => {
      if (item.id == selectedId && !productIsInCart) {
        productIsInCart = true;
      }
    });

    if (!productIsInCart) {
      let formData = {
        'items': [{
          'id': selectedId,
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then((res) => {
        return res;
      });
    }
  });
}
